<template lang="pug">
  .copy-form-data
    .copy-form-data__select
      multiselect.custom-multiselect(
      v-model="fields.shift"
      placeholder="Введите название смены",
      :options="options"
      :label="'name'"
      :multiple="false"
      :showLabels="false"
      :closeOnSelect="true"
      :allowEmpty="false"
      )
        template(
        slot="noOptions"
        ) Список пуст
        template(
        slot="noResult"
        ) Ничего не найдено
    .copy-form-data__switch
      .form-switch
        label.form-switch__label
          input.form-switch__input(
          type="checkbox"
          v-model="fields.state"
          @change="changeState"
          )
          .form-switch__outline
          .form-switch__switch
</template>

<script>
import {mapActions} from "vuex";
import Multiselect from "vue-multiselect";
export default {
  name: "ManagerShiftEditorCopyFormData",
  components: {
    Multiselect
  },
  props: {
    currentData: {
      type: Object,
      default: () => ({})
    },
    currentShift: {
      type: Object,
      default: () => ({})
    },
    options: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      fields: {
        shift: {},
        state: false
      },
      localCurrentData: {}
    };
  },
  methods: {
    ...mapActions(["getShift"]),
    changeState() {
      if (this.fields.state) {
        this.getShift(this.fields.shift.id).then(res => {
          for (const key in this.currentData) {
            this.localCurrentData[key] = this.currentData[key];
          }
          this.$emit("update-field", res);
        });
      } else {
        this.$emit("cancel-update-field", this.localCurrentData);
      }
    }
  },
  mounted() {
    if (this.options.length > 0) {
      this.fields.shift = this.options[0];
    }
  },
  watch: {
    options(val) {
      if (val.length > 0) {
        this.fields.shift = val[0];
      }
    },
    currentShift(val) {
      this.fields.state = false;
    }
  }
};
</script>
